var lib_core = require("lib-core");
var THREE                    = require("three");

/**
 * @constructor
 */
var Editor3DStateMachine = function (root, model) {
    var self = this;
    self.root = root;

    this.model = model;

    lib_core.StateMachine.call(this, this.model.state);

    // keep track of last mouse position for cases where it is not available
    // this happens when events come from above editor (tab etc.)
   this.addEventAction(/.*/,
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE
                    || cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_DOWN
                    || cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_DOWN
                    || cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_UP
                    || cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_WHEEL);
        },
        function(cEvent){
            var pos = cEvent.data('mouseCoord');
            var displacement = pos.sub(self.model.mousePos());
            self.model.mouseDisplacement(displacement);
            self.model.mousePos(pos);
        }
    );

};

lib_core.inherit(Editor3DStateMachine, lib_core.StateMachine);

module.exports = Editor3DStateMachine;
